// extracted by mini-css-extract-plugin
export default {"chart-type-selector":"bg_N9"};